import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass die Dokumenten-Karte erst lädt, wenn der Sidebar-Slot rendert.
 */
const manifest: SkillManifest = {
  key: 'document-generation',
  name: 'Dokumentenerstellung',
  description:
    'Erzeugt PDF/DOCX/JSON pro Projekt-Version und zeigt die Liste der erstellten Dokumente in der Sidebar.',
  category: 'docs',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ, Permission.PROJECT_UPDATE],
  enabledByDefault: true,
};

const DocumentsCard = lazy(() =>
  import('./DocumentsCard').then((m) => ({ default: m.DocumentsCard })),
);

export const documentGenerationSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.sidebar': [
      {
        key: 'documents-card',
        order: 35,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId, readOnly
        render: DocumentsCard,
      },
    ],
  },
};
